/* eslint-disable react/prop-types */
import React, { FC } from "react";
import { Helmet } from "react-helmet";

import { BazaarvoiceRatingsSchema } from "../../helpers/bazaarvoice";

export type ProductStructuredDataProps = {
  name: string;
  description?: string;
  image: string | string[];
  url: string;
  schemaId: string;
  brand: string;
  bazaarvoiceRatingsSchema?: BazaarvoiceRatingsSchema | null;
};

const ProductStructuredData: FC<ProductStructuredDataProps> = ({
  name,
  description,
  image,
  url,
  schemaId,
  brand,
  bazaarvoiceRatingsSchema,
}) => {
  const productSchema = {
    "@context": "https://schema.org",
    "@type": "Product",
    "@id": schemaId,
    name,
    image: Array.isArray(image) ? image : [image],
    ...(description && { description }),
    brand: {
      "@type": "Brand",
      name: brand,
    },
    url,
  };
  const serializeSchema = (schema: unknown) =>
    JSON.stringify(schema).replace(/</g, "\\u003c");
  const scripts = [
    {
      type: "application/ld+json",
      innerHTML: serializeSchema(productSchema),
    },
    ...(bazaarvoiceRatingsSchema
      ? [
          {
            type: "application/ld+json",
            innerHTML: serializeSchema(
              bazaarvoiceRatingsSchema,
            ),
          },
        ]
      : []),
  ];

  return <Helmet script={scripts} />;
};

export default ProductStructuredData;
